import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VTabs,{attrs:{"vertical":""}},[_vm._l((_vm.areas),function(area){return _c(VTab,{key:area.idArea,domProps:{"innerHTML":_vm._s(area.nombre.replace(' ','<br>'))}})}),_vm._l((_vm.areas),function(area){return _c(VTabItem,{key:'a'+area.idArea},[_c('reglaArea',{attrs:{"idArea":area.idArea}})],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }